import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const base = "group inline-flex items-center justify-center gap-3 px-6 h-12 font-display text-base font-semibold uppercase tracking-[0.08em] transition-[background-color,color,border-color] duration-300";
const variants = {
  brand: "bg-brand text-canvas hover:bg-leaf",
  outline: "border border-ink/30 text-ink hover:border-brand hover:text-brand",
  dark: "bg-canvas text-ink hover:bg-brand hover:text-canvas",
};

export const CtaLink = ({ to, children, variant = "brand", testid, className = "" }) => (
  <Link to={to} data-testid={testid} className={`${base} ${variants[variant]} ${className}`}>
    {children}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
  </Link>
);

export const CtaButton = ({ children, variant = "brand", testid, className = "", ...rest }) => (
  <button data-testid={testid} className={`${base} ${variants[variant]} disabled:opacity-60 ${className}`} {...rest}>
    {children}
  </button>
);
